import { Maybe } from 'types/FMSGraphqlTypes'
import { TSmartWayCarrierSchema } from '../components/SmartWayCarrierModal/schema/SmartWayCarrierSchema'
import { TCarrierSmartWayRegistration } from '../types'

export const getSmartWayCarrierDefaultValues = (
  smartWayCarrierPreference: Maybe<TCarrierSmartWayRegistration>
): TSmartWayCarrierSchema => {
  const { isRegistered, renewalDate } = smartWayCarrierPreference || {}
  return {
    isRegistered: isRegistered || false,
    renewalDate: renewalDate || null,
  }
}
